import * as yup from 'yup';
import differenceInDays from 'date-fns/differenceInDays'; // <--- IMPORTANTE
import { CreateReprocessForm, ReprocessType } from '../../types';

export const typesWithDate = [
  ReprocessType.sales,
  ReprocessType.collections,
  ReprocessType.store,
  ReprocessType.economicAccounting,
];

export const typesWithStore = [
  ReprocessType.sales,
  ReprocessType.collections,
  ReprocessType.store,
  ReprocessType.economicAccounting,
];

export const COUNTRIES_OPTIONAL_STORE = ['PA', 'MX', 'EC', 'BR', 'UY'];
const COUNTRIES_ONE_DAY_WITHOUT_STORE = ['MX', 'EC', 'UY'];
const COUNTRIES_MAX_ONE_DAY_RANGE = ['BR'];

export const getSchema = (maxRangeDays = 5): yup.ObjectSchema<CreateReprocessForm> =>
  yup.object().shape({
    country: yup.string().required(),
    store: yup.string().when('country', {
      is: (country: string) => !COUNTRIES_OPTIONAL_STORE.includes(country),
      then: schema => schema.required(),
      otherwise: schema => schema.optional(),
    }),
    businessDateFrom: yup.date().required(),
    businessDateTo: yup
      .date()
      .required()
      .min(yup.ref('businessDateFrom'), "La fecha 'Hasta' debe ser posterior a 'Desde'")
      .test('max-range-days', '', function (businessDateTo) {
        const { businessDateFrom, country, store } = this.parent;
        if (!businessDateTo || !businessDateFrom) return true;

        const diff = differenceInDays(businessDateTo, businessDateFrom);

        if (COUNTRIES_MAX_ONE_DAY_RANGE.includes(country) && diff > 0) {
          return this.createError({
            message: 'Para Brasil el rango no puede superar 1 día',
          });
        }

        if (COUNTRIES_ONE_DAY_WITHOUT_STORE.includes(country) && !store) {
          if (diff > 0) {
            return this.createError({
              message: 'Para ejecución de mercado completo el rango no puede superar 1 día',
            });
          }
          return true;
        }

        if (diff >= maxRangeDays) {
          return this.createError({
            message: `El rango no puede superar los ${maxRangeDays} días`,
          });
        }
        return true;
      }),
    justification: yup.string().required().max(80),
  });
